import { render, staticRenderFns } from "./receiveRecord.vue?vue&type=template&id=489a44ae&"
import script from "./receiveRecord.vue?vue&type=script&lang=js&"
export * from "./receiveRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports